import { MagnifyingGlassIcon } from '@cmp-src/icons/TacticIcons/MagnifyingGlassIcon';
import { ReactNode, useState } from 'react';
import { Button } from '@cmp-src/buttons/Button';

// Add proper typing for the column filter props
export interface NameColumnFilterProps {
  column: {
    filterValue: string;
    setFilter: (value: string) => void;
  };
  UserSearch: ReactNode | undefined;
}

export const NameColumnFilter: React.FC<NameColumnFilterProps> = ({
  column: { filterValue, setFilter },
  UserSearch
}) => {
  // const [searchIsActive, setSearchIsActive] = useState(false);

  // TBD: reuse as custom select trigger
  // if (!searchIsActive) {
  //   return (
  //     <Button
  //       className="flex flex-row items-center justify-start gap-2 font-bold"
  //       variant="invisible"
  //       font="custom"
  //       onClick={() => setSearchIsActive(true)}
  //     >
  //       <div>Employee</div>

  //       <MagnifyingGlassIcon
  //         className="h-4 w-4"
  //         onClick={() => setSearchIsActive(true)}
  //       />
  //     </Button>
  //   );
  // }

  return <div className="relative">{UserSearch}</div>;
};
